import BlogItem from "@/app/components/blog-item";
import React from "react";

interface BlogSidebarProps {
    recentPosts: Array<{
        id: number;
        title: string;
        minRead: string;
        image: {
            url: string;
        };
        metaData: {
            slug: string;
        };
    }>;
    lang: string;
}

const BlogSidebar: React.FC<BlogSidebarProps> = ({ recentPosts, lang }) => {
    
    const isEn = lang.startsWith("en");

    return (
        <section className="mt-[42px] mb-[400px] max-[767px]:mb-[64px]">
            <div className="container">
                <h2 className="text-[16px] text-gray-600 font-bold uppercase mb-[16px]">MIGHT BE INTERESTING</h2>
                <div className="flex flex-col space-y-[32px]">
                    {recentPosts.map((post) => (
                        <BlogItem 
                            key={post.id}
                            title={post.title}
                            image={post.image.url}
                            link={`${isEn ? '/en' : ''}/blog/${encodeURIComponent(post.metaData.slug)}`}
                            minRead={post.minRead}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BlogSidebar;